import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'react-fa';
import { withRouter } from 'react-router';
import { compose } from 'recompose';

import bindReduceStore from '../components/hocs/bindReduceStore.react';
import auth from '../config/auth0-config';
import Logo from '../components/Logo.react';

import LoginStylingStore from '../stores/LoginStylingStore';
import LastAuthenticationAttemptStore from '../stores/LastAuthenticationAttemptStore';

import { showZenDeskOverlay } from '../util/zendesk';

function getState() {
  const googleLogout = sessionStorage.getItem('googleLogout');
  sessionStorage.removeItem('googleLogout');
  return {
    wasGoogleLogout: googleLogout,
  };
}

const redirectToLogin = () => auth.login();

const LoginMessage = ({ lastLogin }) => {
  if (lastLogin.success === false) {
    return <div className='login-message'>{lastLogin.message} Click below to try again.</div>;
  }

  return <div className='login-message'>Click below to log in.</div>;
};

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = getState();
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    setTimeout(() => showZenDeskOverlay());
  }

  componentWillUnmount() {
    document.body.className = '';
  }

  _onChange() {
    this.setState(getState());
  }

  render() {
    return (
      <div className='login'>
        <header className='brand-name'>
          <div className='logoWrapper animated fadeInLeft'>
            <Logo appName={this.props.styling.appName} />
            { this.props.styling.subTitle && (
              <h4>
                {this.props.styling.subTitle}
              </h4>
            )}
            <h4>Powered by <img alt='BlueLabs' src='/assets/logo/bluelabs-full-med.png' height={45} /></h4>
            {
              this.state.wasGoogleLogout && (
                <p className='warning'>
                  <Icon name='exclamation-circle' />
                  You have logged out of BlueHQ, but are still logged into Google.
                  If you are on a shared computer,
                  <a href='https://accounts.google.com/logout'> click here to logout</a>
                </p>
              )
            }
          </div>
        </header>
        <div id='login-container'>
          <LoginMessage lastLogin={this.props.lastLogin} />
          <button className='login-button' onClick={redirectToLogin}>
            Login
          </button>
        </div>
      </div>
    );
  }
}

const lastLoginShape = {
  success: PropTypes.bool,
  message: PropTypes.string,
};

const stylingShape = {
  appName: PropTypes.string,
  subTitle: PropTypes.string,
};

LoginMessage.propTypes = {
  lastLogin: PropTypes.shape(lastLoginShape),
};

Login.propTypes = {
  lastLogin: PropTypes.shape(lastLoginShape),
  styling: PropTypes.shape(stylingShape),
};

export default compose(
  bindReduceStore(LoginStylingStore, 'styling'),
  bindReduceStore(LastAuthenticationAttemptStore, 'lastLogin'),
  withRouter,
)(Login);
